import React from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import {
  resolveSpeakerRole,
  roleBadgeClassName,
  type RoleBadgeVariant,
} from '../../../utils/speaker-roles';

const cn = createCn('file', classes);

type Props = {
  raw: string;
  explicitRole?: string;
  className?: string;
};

function roleClass(variant: RoleBadgeVariant): string {
  return roleBadgeClassName(variant);
}

const SpeakerRoleBadge = ({ raw, explicitRole, className }: Props) => {
  const resolved = resolveSpeakerRole(raw, explicitRole);
  return (
    <span
      className={[
        cn('protocol-role-badge', { [roleClass(resolved.variant)]: true }),
        className,
      ].filter(Boolean).join(' ')}
    >
      {resolved.label}
    </span>
  );
};

export default SpeakerRoleBadge;
